export default __webpack_public_path__ + "static/ID700-ios-large-1-f6cf5d96ee46d1e50a65978f69e99893.png";